<template>
<div class="chapter">
<div class="inner_page">
<p class="sp1" id="ded"> </p>
<p class="Dedication-ded">For my daughter Emily, the fiercest warrior I know. Keep fighting, you’re worth the fight. Learn and grow stronger from every battle, every loss, every victory.</p>
<p class="sp"> </p>
<p class="Dedication-ded-first">    To the memory of Leslie Phillips Barger.</p>
<p class="Dedication-ded-first"> </p>
<p class="Dedication-ded-first">    “If a thing loves, it is infinite.”</p>
<p class="Dedication-ded-first"> </p>
<p class="Dedication-ded-last">—William Blake</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?4caf9dc3